import { createRouter, createWebHashHistory } from 'vue-router'


const routes = [
  // pc
  {
    path: '/pc',
    name: '首页',
    component: () => import('../views/pc/Home/Home.vue')
  },
  {
    path: '/pc/about',
    name: '关于畅月',
    component: () => import('../views/pc/About/About.vue'),
  },
  {
    path: '/pc/product',
    name: '产品中心',
    component: () => import('../views/pc/Product/Product.vue'),
    children: [
      {
        path: 'adminsystem',
        name: '数字家园管理系统',
        component: () => import('../views/pc/Product/ProductChildren/AdminSystem.vue')
      },
      {
        path: 'things',
        name: '物联网平台',
        component: () => import('../views/pc/Product/ProductChildren/Things.vue')
      },
      {
        path: 'property',
        name: '物业APP、小程序',
        component: () => import('../views/pc/Product/ProductChildren/Property.vue')
      },
      {
        path: 'resident',
        name: '居民APP、小程序',
        component: () => import('../views/pc/Product/ProductChildren/Resident.vue')
      },
      {
        path: 'workorder',
        name: '物业工单系统',
        component: () => import('../views/pc/Product/ProductChildren/WorkOrder.vue')
      },
    ]
  },
  {
    path: '/pc/programme',
    name: '解决方案',
    component: () => import('../views/pc/Programme/Programme.vue'),
    children: [
      {
        path: 'accesscontrol',
        name: '智能门禁',
        component: () => import('../views/pc/Programme/ProgrammeChildren/AccessControl.vue'),
      },
      {
        path: 'community',
        name: '智慧社区',
        component: () => import('../views/pc/Programme/ProgrammeChildren/Community.vue'),
      },
      {
        path: 'doorpost',
        name: '无人门岗',
        component: () => import('../views/pc/Programme/ProgrammeChildren/Doorpost.vue'),
      },
      {
        path: 'monitor',
        name: '智能监控',
        component: () => import('../views/pc/Programme/ProgrammeChildren/Monitor.vue'),
      },
      {
        path: 'property',
        name: '智慧物业',
        component: () => import('../views/pc/Programme/ProgrammeChildren/Property.vue'),
      },
      {
        path: 'security',
        name: '智能安防',
        component: () => import('../views/pc/Programme/ProgrammeChildren/Security.vue'),
      },
      {
        path: 'intercom',
        name: '楼宇对讲',
        component: () => import('../views/pc/Programme/ProgrammeChildren/Intercom.vue'),
      },
      {
        path: 'logistics',
        name: '智慧后勤',
        component: () => import('../views/pc/Programme/ProgrammeChildren/Logistics.vue'),
      },
      {
        path: 'firecontrol',
        name: '智能消防',
        component: () => import('../views/pc/Programme/ProgrammeChildren/FireControl.vue'),
      },
      {
        path: 'laddercontrol',
        name: '智能梯控',
        component: () => import('../views/pc/Programme/ProgrammeChildren/LadderControl.vue'),
      },
      {
        path: 'communityadmin',
        name: '社区管理',
        component: () => import('../views/pc/Programme/ProgrammeChildren/CommunityAdmin.vue'),
      },
      {
        path: 'financeadmin',
        name: '财务管理',
        component: () => import('../views/pc/Programme/ProgrammeChildren/FinanceAdmin.vue'),
      },
      {
        path: 'homefurnishing',
        name: '智能家居',
        component: () => import('../views/pc/Programme/ProgrammeChildren/HomeFurnishing.vue'),
      },
      {
        path: 'charge',
        name: '智能充电',
        component: () => import('../views/pc/Programme/ProgrammeChildren/Charge.vue'),
      },
      {
        path: 'parking',
        name: '智能停车',
        component: () => import('../views/pc/Programme/ProgrammeChildren/Parking.vue'),
      },
      {
        path: 'energyconsumption',
        name: '智能能耗',
        component: () => import('../views/pc/Programme/ProgrammeChildren/EnergyConsumption.vue'),
      },
      {
        path: 'businessdistrict',
        name: '智慧商圈',
        component: () => import('../views/pc/Programme/ProgrammeChildren/BusinessDistrict.vue'),
      },
      {
        path: 'epidemicprevention',
        name: '智慧防疫',
        component: () => import('../views/pc/Programme/ProgrammeChildren/EpidemicPrevention.vue')
      }
    ]
  },
  {
    path: '/pc/dynamic',
    name: '资讯动态',
    component: () => import('../views/pc/Dynamic/Dynamic.vue'),
    children: [
      {
        path: 'newsdetails',
        name: '行业新闻详情',
        component: () => import('../views/pc/Dynamic/DynamicChildren/NewsDetails.vue')
      },
      {
        path: 'dynamicdetails',
        name: '公司动态详情',
        component: () => import('../views/pc/Dynamic/DynamicChildren/DynamicDetails.vue')
      }
    ]
  },
  {
    path: '/pc/party',
    name: '党建引领',
    component: () => import('../views/pc/Party/Party.vue'),
    children: [
      {
        path: 'partydetails',
        name: '党建要闻详情',
        component: () => import('../views/pc/Party/PartyChildren/PartyDetails.vue'),
      }
    ]
  },
  {
    path: '/pc/contact',
    name: '联系我们',
    component: () => import('../views/pc/Contact/Contact.vue')
  },


  // mobile
  {
    path: '/mobile',
    name: '移动端首页',
    component: () => import('../views/mobile/Home/Home.vue')
  },
  {
    path: '/mobile/downloaduserapp',
    name: '下载用户App',
    component: () => import('../views/mobile/downloadApp/downloadUserApp.vue')
  },
  {
    path: '/mobile/downloadworkapp',
    name: '下载员工App',
    component: () => import('../views/mobile/downloadApp/downloadWorkApp.vue')
  },
  {
    path: '/mobile/about',
    name: '移动端关于畅月',
    component: () => import('../views/mobile/About/About.vue'),
  },
  {
    path: '/mobile/product',
    name: '移动端产品中心',
    component: () => import('../views/mobile/Product/Product.vue'),
    children: [
      {
        path: 'adminsystem',
        name: '移动端数字家园管理系统',
        component: () => import('../views/mobile/Product/ProductChildren/AdminSystem.vue')
      },
      {
        path: 'things',
        name: '移动端物联网平台',
        component: () => import('../views/mobile/Product/ProductChildren/Things.vue')
      },
      {
        path: 'property',
        name: '移动端物业APP、小程序',
        component: () => import('../views/mobile/Product/ProductChildren/Property.vue')
      },
      {
        path: 'resident',
        name: '移动端居民APP、小程序',
        component: () => import('../views/mobile/Product/ProductChildren/Resident.vue')
      },
      {
        path: 'workorder',
        name: '移动端物业工单系统',
        component: () => import('../views/mobile/Product/ProductChildren/WorkOrder.vue')
      },
    ]
  },
  {
    path: '/mobile/programme',
    name: '移动端解决方案',
    component: () => import('../views/mobile/Programme/Programme.vue'),
    children: [
      {
        path: 'accesscontrol',
        name: '移动端智能门禁',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/AccessControl.vue'),
      },
      {
        path: 'community',
        name: '移动端智慧社区',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/Community.vue'),
      },
      {
        path: 'doorpost',
        name: '移动端无人门岗',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/Doorpost.vue'),
      },
      {
        path: 'monitor',
        name: '移动端智能监控',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/Monitor.vue'),
      },
      {
        path: 'property',
        name: '移动端智慧物业',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/Property.vue'),
      },
      {
        path: 'security',
        name: '移动端智能安防',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/Security.vue'),
      },
      {
        path: 'intercom',
        name: '移动端楼宇对讲',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/Intercom.vue'),
      },
      {
        path: 'logistics',
        name: '移动端智慧后勤',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/Logistics.vue'),
      },
      {
        path: 'firecontrol',
        name: '移动端智能消防',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/FireControl.vue'),
      },
      {
        path: 'laddercontrol',
        name: '移动端智能梯控',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/LadderControl.vue'),
      },
      {
        path: 'communityadmin',
        name: '移动端社区管理',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/CommunityAdmin.vue'),
      },
      {
        path: 'financeadmin',
        name: '移动端财务管理',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/FinanceAdmin.vue'),
      },
      {
        path: 'homefurnishing',
        name: '移动端智能家居',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/HomeFurnishing.vue'),
      },
      {
        path: 'charge',
        name: '移动端智能充电',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/Charge.vue'),
      },
      {
        path: 'parking',
        name: '移动端智能停车',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/Parking.vue'),
      },
      {
        path: 'energyconsumption',
        name: '移动端智能能耗',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/EnergyConsumption.vue'),
      },
      {
        path: 'businessdistrict',
        name: '移动端智慧商圈',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/BusinessDistrict.vue'),
      },
      {
        path: 'epidemicprevention',
        name: '移动端智慧防疫',
        component: () => import('../views/mobile/Programme/ProgrammeChildren/EpidemicPrevention.vue')
      }
    ]
  },
  {
    path: '/mobile/dynamic',
    name: '移动端资讯动态',
    component: () => import('../views/mobile/Dynamic/Dynamic.vue'),
    children: [
      {
        path: 'newsdetails',
        name: '移动端行业新闻详情',
        component: () => import('../views/mobile/Dynamic/DynamicChildren/NewsDetails.vue')
      },
      {
        path: 'dynamicdetails',
        name: '移动端公司动态详情',
        component: () => import('../views/mobile/Dynamic/DynamicChildren/DynamicDetails.vue')
      }
    ]
  },
  {
    path: '/mobile/party',
    name: '移动端党建引领',
    component: () => import('../views/mobile/Party/Party.vue'),
    children: [
      {
        path: 'partydetails',
        name: '移动端党建要闻详情',
        component: () => import('../views/mobile/Party/PartyChildren/PartyDetails.vue'),
      }
    ]
  },
  {
    path: '/mobile/contact',
    name: '移动端联系我们',
    component: () => import('../views/mobile/Contact/Contact.vue')
  },
]

document.title = '畅月数字家园官网';

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
